<template>
  <div class="col pt-4 p-md-4">
    <h5
      id="user-address-head"
      class="mywishlist"
						data-test="addressHeading"
    >
      My Addresses
    </h5>
    <hr class="mywishlist">
			<page-loader v-if="showLoader">
			</page-loader>
    <div class="row">
      <div class="col-12">
							<div v-if="!showAddAddressForm && !showLoader">
								<address-list-template
									v-for="address in customerAddress"
									:key="address.addressLine1"
									:address="address"
									:showInputRadio="false"
									@delete="deleteAddress($event)"
								/>
							</div>
							<div
								class="col-12 card p-3"
								v-if="!showAddAddressForm && !showLoader"
							>
								<div
									class="custom-control custom-radio"
									id="user-address-radio"
								>
									<a
										class=""
										data-toggle="collapse"
										href="#addnew-address"
										role="button"
										aria-expanded="false"
										aria-controls="collapseExample"
										@click.prevent="showAddAddressForm = true"
										id="user-address-form-link"
										data-test="addressNewLink"
									>
										<label
											class="custom-control-label"
											id="user-add-address"
											data-test="addressAddNewLabel"
										>
											Add New
										</label>
									</a>
								</div>
							</div>
      </div>
      <address-form
        v-if="showAddAddressForm"
        @cancel="showAddAddressForm = false"
        @submitSuccess="addOrUpdateAddress($event)"
      >
      </address-form>
    </div>
  </div>
</template>

<script>
import { customerApi } from '@/services/ApiServices/customerApi'
import AddressListTemplate from '@/components/widgets/user/AddressListTemplate'
import AddressForm from '@/components/shared/forms/AddressForm'
import PageLoader from '../../../shared/loader/pageLoader'

export default {
	beforeMount () {
		this.bindCustomerAddress()
	},
	data () {
		return {
			customerAddress: [],
			showAddAddressForm: false,
			showLoader: true
		}
	},
	components: {
		PageLoader,
		AddressListTemplate,
		AddressForm
	},
	methods: {
		bindCustomerAddress () {
			customerApi.getAddresses()
				.then((res) => {
					if (res.body) {
						this.customerAddress = res.body
						this.showLoader = false
					}
				}).catch((e) => {
					this.showLoader = false
				})
		},
		addOrUpdateAddress (addressdata) {
			customerApi.addAddress(addressdata).then((res) => {
				this.bindCustomerAddress()
				this.showAddAddressForm = false
			})
		},
		deleteAddress (addressId) {
			this.$dialog
				.confirm('Are you sure you want to delete this address?')
				.then((dialog) => {
					this.editEnabled = false
					customerApi.removeAddress(addressId).then((res) => {
						this.$toasted.show('Successfully deleted the address', {
							icon: 'exclamation-circle',
							position: 'bottom-center'
						})
						this.bindCustomerAddress()
						this.$forceUpdate()
						this.showAddAddressForm = false
					})
				})
				.catch(() => {
					// console.log('Clicked on cancel')
				})
		}
	}
}
</script>
